// extracted by mini-css-extract-plugin
module.exports = {"bgIcon":"Flows_bgIcon__zKqjz","bgIconTopRightCenter":"Flows_bgIconTopRightCenter__dolFS","bgIconTopRight":"Flows_bgIconTopRight__awF9F"};